import { SmallTile } from '#/components/Tile/SmallTile';
import { uuid } from '#/utils/functional/string/uuid';

import { SearchLoadingSectionLine } from './SearchLoadingSectionLine';
import {
  SearchLoadingSectionMockResultsItem_Box_1,
  SearchLoadingSectionMockResultsItem_Box_2,
} from './SearchLoadingSectionMockResultsItem.styled';

type Props = {
  hideLabel?: boolean;
};

export function SearchLoadingSectionMockResultsItem({ hideLabel }: Props) {
  return (
    <SmallTile key={uuid()} type="inert">
      <SearchLoadingSectionMockResultsItem_Box_2>
        <SearchLoadingSectionMockResultsItem_Box_1>
          <SearchLoadingSectionLine
            style={{ width: 120, height: 120, borderRadius: '50%' }}
          />
        </SearchLoadingSectionMockResultsItem_Box_1>
        <div
          style={{
            position: 'relative',
            width: '100%',
            flex: '1 1 auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          {!hideLabel && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 32,
              }}
            >
              <SearchLoadingSectionLine
                style={{
                  width: 16,
                  height: 16,
                  marginRight: 12,
                  borderRadius: '50%',
                }}
              />

              <SearchLoadingSectionLine style={{ width: 120, height: 10 }} />
            </div>
          )}
          <SearchLoadingSectionLine style={{ width: '82.5%', height: 20 }} />
          <SearchLoadingSectionLine
            style={{ width: '95%', height: 12, marginTop: 16 }}
          />
          <SearchLoadingSectionLine
            style={{ width: 160, height: 8, marginTop: 32 }}
          />
        </div>
      </SearchLoadingSectionMockResultsItem_Box_2>
    </SmallTile>
  );
}
